import jacobPic from "@/public/images/artists/jacob.png";
import { Artist } from "@/types/types";

export const jacob = {
  id: "27",
  name: "Jacob",
  image: jacobPic,
  description: `Meet "Jacob," the charismatic pop singer. With a voice that radiates charm, Jacob brings a magnetic energy to every track he performs.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjacob-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance"],
      secondary: ["Singer", "Smooth", "Heartfelt"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
